import { useTranslation } from 'react-i18next';

import { stationDetailAgenda } from '@/modules/products/stations';
import { useNavigator } from '@/shared/navigation/react/useNavigator';
import { EntityEditLink } from './EntityEditLink';

interface StationLinkProps {
  /** Id stanice — parametr detailu stanice. */
  stationId: number;
  /** Zobrazený text stanice (např. její název). */
  children: React.ReactNode;
}

/** Text stanice s tlačítkem, které otevře detail stanice. */
export function StationLink({ stationId, children }: StationLinkProps) {
  const { t } = useTranslation('venua-planner');
  const navigator = useNavigator();
  return (
    <EntityEditLink
      editLabel={t('actions.editStation')}
      onEdit={() => void navigator.openModal(stationDetailAgenda, { stationId })}
    >
      {children}
    </EntityEditLink>
  );
}
